import {
	GroupData,
	GroupMode,
	ItemEntityType,
	ItemsByGroup,
	PaginationRequestGroup,
	PaginationRequestItem
} from '@bringg/types';
import { getRoot } from 'mobx-easy';

import RootStore from '../../../../stores/root-store';

const PAGE_SIZE = 150;

function create(groups: GroupData[], itemsByGroup: ItemsByGroup, entityType: ItemEntityType, limit = PAGE_SIZE) {
	return {
		limit,
		from:
			groups.length > 0
				? getNextFromRecursion(groups[groups.length - 1], itemsByGroup, [], entityType)
				: undefined
	};
}

function getNextFromRecursion(
	group: GroupData,
	itemsByGroup: ItemsByGroup,
	from: (PaginationRequestGroup | PaginationRequestItem)[],
	entityType: ItemEntityType
): (PaginationRequestGroup | PaginationRequestItem)[] {
	if (!group) {
		return from;
	}

	if (group.id === GroupMode.None) {
		from.push({
			pagination_id_value: itemsByGroup[GroupMode.None][itemsByGroup[GroupMode.None].length - 1]?.id,
			pagination_value: itemsByGroup[GroupMode.None][itemsByGroup[GroupMode.None].length - 1]?.id //todo - take field from sorting
		});
		return from;
	}

	if (!group.groups) {
		let paginationValue = group.data.title;

		if (group.group_type === 'route') {
			const run = getRoot<RootStore>().data.runStore.get(group.data.id);
			paginationValue = run?.started_at || run?.scheduled_start_time;
		}

		from.push({
			group_type: group.group_type,
			pagination_value: paginationValue,
			pagination_id_value: group.data.id
		});

		if (entityType === 'task') {
			const value = itemsByGroup[group.id][itemsByGroup[group.id].length - 1]?.id;
			from.push({ pagination_id_value: value, pagination_value: value });
		}

		return from;
	} else {
		from.push({ group_type: group.group_type, pagination_value: group.data.title });

		return entityType === 'task'
			? getNextFromRecursion(group.groups[group.groups.length - 1], itemsByGroup, from, entityType)
			: from;
	}
}

export const loaderPageCreator = { create, PAGE_SIZE };
